import { FC } from 'react';
import { Avatar, AvatarProps } from 'antd';
import { TbFile } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import useAttachmentFilePresentation, {
    AttachmentFilePresentation,
} from '../AttachmentFileList/useAttachmentFilePresentation';

interface AttachmentFileAvatarProps {
    mimeType: string;
    presentation?: AttachmentFilePresentation;
    size?: AvatarProps['size'];
}

const AttachmentFileAvatar: FC<AttachmentFileAvatarProps> = ({ mimeType, presentation, size = 'large' }) => {
    const { token } = useAntDesignTheme();
    const presentations = useAttachmentFilePresentation();
    const resolvedPresentation = presentation ?? presentations[mimeType.split(';')[0].trim().toLowerCase()];

    return (
        <Avatar
            icon={resolvedPresentation?.icon ?? <TbFile color={token.colorTextTertiary} />}
            shape='square'
            size={size}
            style={{
                backgroundColor: resolvedPresentation?.background ?? token.colorBgContainer,
                border: `1px solid ${resolvedPresentation?.borderColor ?? token.colorBorder}`,
            }}
        />
    );
};

export default AttachmentFileAvatar;
